<template>
	<div>
		<div class="c-oembed" v-if="show">
			<a
				:href="oembedData.videoUrl"
				target="_blank"
				rel="noopener"
				v-if="oembedData.oembedIs360 && unsupported"
				class="c-oembed__fallback-image"
				:style="'background-image:url(' + oembedData.fallbackImage.sizes.bandara_medium + ')'">
				<span v-if="isSafariOnOsx">{{ localizedNotSupportedText }}</span><span v-else>{{ localizedOpenYouTubeText }}</span>
			</a>
			<div class='c-oembed__container'>
				<div v-append="oembedData.oembed" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'oembed',
	props: ['oembedData'],
	data: () => ({
		unsupported: true,
		isSafariOnOsx: false,
		outputPrint: '',
		show: false,
		notSupportedText: {
			'en-us': 'Your browser does not support 360° video playback. Please use Chrome.',
			'de-ch': 'Ihr Browser unterstützt keine 360° Videos. Bitte benutzen Sie Chrome.'
		},
		openYouTubeText: {
			'en-us': 'Open 360° video in YouTube app',
			'de-ch': '360° Video in der YouTube-App öffnen'
		}
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		localizedNotSupportedText() {
			return this.notSupportedText[this.settings.currentLang]
		},
		localizedOpenYouTubeText() {
			return this.openYouTubeText[this.settings.currentLang]
		}
	},
	mounted() {
		if(this.browserSupports360()) this.unsupported = false
		this.show = true
	},
	watch: {
		'oembedData': function() {
			this.show = false
			this.$nextTick(() => {
				this.show = true
			})
		}
	},
	methods: {
		browserSupports360() {
			const parse = require('ua-parser-js')
			const ua = parse(navigator.userAgent)
			const browser = ua.browser

		  // YouTube supports 360 videos in a limited set of browsers,
		  // see https://support.google.com/youtube/answer/6178631

			// console.log(ua)
			// console.log(browser)

			this.outputPrint = `name: ${browser.name}, version: ${browser.major}, engine: ${ua.engine.name}, os: ${ua.os.name}`

			// if (browser.name === 'Samsung Browser' || browser.name === 'Android Browser') return false
			if (ua.os.name === 'Android' && browser.name !== 'Chrome') return false
			if (ua.os.name === 'iOS') return false
			if (browser.name === 'Chrome' && browser.major >= 40) return true
			if (browser.name === 'Firefox' && browser.major >= 40) return true
			if (browser.name === 'Edge') return true
			if (browser.name === 'Opera' && browser.major >= 30) return true
			if (browser.name === 'Safari' && ua.os.name === 'Mac OS') {
				this.isSafariOnOsx = true
				return false
			}

			return false
		}
	}
};
</script>

<style lang="scss">

@import '../assets/css/helpers';

$m: 'c-oembed';

.#{$m} {
	position: relative;
	width: 100%;
	max-width: 45rem;

	&__fallback-image {
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		position: absolute;
		background-color: rgba($colorBrandSecondary, .8);
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
		color: #fff;
		display: flex;
		align-items: flex-end;
		text-decoration: none;

		&::before {
			content: "";
			display: block;
			width: 4rem;
			height: 4rem;
			background: rgba($colorBrandSecondary, .8);
			position: absolute;
			top: 50%;
			left: 50%;
			color: #fff;
			margin-left: -2rem;
			margin-top: -2.5rem;
			border-radius: 100%;
			text-align: center;
			line-height: 4rem;
			font-size: 1.75rem;
			box-sizing: border-box;
			padding-left: .5rem;
			transition: .2s background;
		}
		&::after {
			content: "";
			display: block;
			width: 0;
			height: 0;
			border: 1rem solid #fff;
			border-top-color: rgba(#fff, 0);
			border-left-color: rgba(#fff, 0);
			transform: scale(1, .7) rotate(-45deg);
			margin-top: -1.5rem;
			margin-left: -1.4rem;
			position: absolute;
			top: 50%;
			left: 50%;
		}

		span {
			width: 100%;
			text-align: center;
			color: #fff;
			text-decoration: none;
			background-color: rgba($colorBrandSecondary, .8);
			padding: .5rem 0;
			font-size: .9rem;
		}

		&:hover {
			&::before {
				background: rgba($colorBrandSecondary, 1);
			}
		}
	}
	&__container {
		position: relative;
		padding-bottom: 56.25%;
		height: 0;
		overflow: hidden;
		max-width: 100%;

		iframe, object, embed {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}
}

</style>



// WEBPACK FOOTER //
// OEmbed.vue?11247255